module.exports = __webpack_public_path__ + "img/instructor3.13ed54b9.webp";